import { Component } from '@angular/core';

@Component({
    selector: 'wci-privacy',
    imports: [],
    templateUrl: './privacy.component.html',
    styles: ``,
})
export class PrivacyComponent {}
